


















import mixin from './cardmixin.vue'
import Vue from 'vue'
import dayjs from 'dayjs'
import { AlarmStatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
const assp = new AlarmStatisticsServiceProxy()

export default Vue.extend({
  name: 'device-alarm-table',
  mixins: [mixin],
  data() {
    return {
      data: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_card_workstation_code'),
          dataIndex: 'workStationCode',
          width: 160
        },
        {
          title: this.$t('page_card_workstation_name'),
          dataIndex: 'workStationName',
          width: 100
        },
        {
          title: this.$t('page_card_alarm_code'),
          dataIndex: 'alarmCode',
          width: 100
        },
        {
          title: this.$t('page_card_alarm_msg'),
          dataIndex: 'alarmMsg',
          width: 200
        },
        {
          title: this.$t('page_card_alarm_time'),
          dataIndex: 'alarmTime',
          width: 120,
          scopedSlots: { customRender: 'time' }
        }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    async getList() {
      const { records } = await assp.alarmTodayDetail(0, 50)
      this.data = records
      this.checkScrollY('device-alarm', this.data.length)
    }
  }
})
